// extracted by mini-css-extract-plugin
export default {"backlay":"Backlay_backlay__NXR5x"};